module.exports = __webpack_public_path__ + "static/media/features-split-image-03.b0ac8535.png";